import { Link } from "react-router-dom";
import "./bottomNavigation.scss";

// One tab of the bottom bar. Icon-only by design; the Persian name lives in
// aria-label/title only. Active state is URL-driven (aria-current + modifier
// class + data-active hook) so refresh and browser back/forward just work.
function BottomNavigationItem({ itemKey, to, label, title, Icon, active, disabled }) {
  const icon = (
    <>
      <span className="bottom-nav__icon-wrap" aria-hidden="true">
        <span className="bottom-nav__icon">
          <Icon />
        </span>
      </span>
      <span className="bottom-nav__dot" aria-hidden="true" />
    </>
  );

  if (disabled) {
    return (
      <li className="bottom-nav__item">
        <button
          type="button"
          disabled
          aria-disabled="true"
          aria-label={label}
          title={title}
          data-testid={`bottom-nav-${itemKey}`}
          data-active="false"
          className="bottom-nav__link bottom-nav__link--disabled"
          onClick={(e) => e.preventDefault()}
        >
          {icon}
        </button>
      </li>
    );
  }

  return (
    <li className="bottom-nav__item">
      <Link
        to={to}
        title={title}
        aria-label={label}
        aria-current={active ? "page" : undefined}
        data-testid={`bottom-nav-${itemKey}`}
        data-active={active ? "true" : "false"}
        className={`bottom-nav__link${active ? " bottom-nav__link--active" : ""}`}
      >
        {icon}
      </Link>
    </li>
  );
}

export default BottomNavigationItem;
